/// <amd-module name="VC/Markdown/Plugins/PathUtilities/VersionControlPath" />

/*
 * This file was ported from the legacy webplatform
 * Logic that is not needed for markdown token transformation was not ported over.
 * Logic has only been changed where necessary to interact in the modern web platform.
 * There is no intention to change any factorings or style otherwise.
 */
export const pathSeparator = "/";
export const gitRootPath = "/";
export const tfvcRootPath = "$/";

/**
 * Gets the containing directory of the last path component.
 * @param path The path
 * @returns Path characters up to and including the last slash.
 *          Empty string if the path contains no slash.
 */
export function getDirectory(path: string) {
    let pos: number;

    if (path) {
        pos = path.lastIndexOf(pathSeparator);
        if (pos >= 0) {
            return path.substr(0, pos + 1);
        }
    }

    return "";
}

export function getFileExtension(path: string) {
    let extension = "";
    const dotIndex = (path || "").lastIndexOf(".");

    if (dotIndex >= 0) {
        extension = path.substring(dotIndex + 1);
    }

    return extension;
}
